import React from 'react';
import { Tab as SemanticTab } from 'semantic-ui-react';
import './styles.scss';

interface TabProps {
  [key: string]: any;
}

const Tab: React.FC<TabProps> = (props) => {
  const defaultProps = {
    menu: {
      secondary: true,
      pointing: true
    }
  };

  const mergedProps = { ...defaultProps, ...props };

  return (
    <div className="custom-tab-wrapper">
      <SemanticTab {...mergedProps} />
    </div>
  );
};

export default Tab;